/* THIS FILE IS GENERATED. DO NOT EDIT */

import theme from 'sites/allas/components/standalone/ArticleHeader/theme';

export const ArticleHeaderTheme = theme;
